import "../App.css";

const DialogoLoading = () => {
 
  return (
    <div  id="modalLoading" className="modal" tabIndex="-1" role="dialog">
      <div className="modal-dialog-centered" role="document">
        <div style={{ backgroundColor: "#FFFFFF10" }} className="modal-content">
          <img
            style={{ width: "15%", height: "auto" }}
            className="centerImg"
            src={process.env.REACT_APP_URL_ROOT + "Images/Config/loading.gif"}
            alt=""
          ></img>
          <div style={{ display: "none" }} className="modal-footer">
            <button
              id="btnCloseModalLoading"
              type="button"
              className="btn btn-secondary"
              data-dismiss="modal"
            ></button>
            <button
              id="btnOpenModalLoading"
              type="button"
              data-toggle="modal"
              data-target="#modalLoading"
            ></button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DialogoLoading;
